module.exports = __webpack_public_path__ + "img/team.c0688f00.jpg";